const disputeActionConstants = {
  GET_DISPUTES: 'GET_DISPUTES',
  GET_DISPUTES_SUCCESS: 'GET_DISPUTES_SUCCESS',
  GET_DISPUTES_ERROR: 'GET_DISPUTES_ERROR',

  GET_DISPUTE_DETAILS: 'GET_DISPUTE_DETAILS',

  CREATE_DISPUTE: 'CREATE_DISPUTE',
  CREATE_DISPUTE_SUCCESS: 'CREATE_DISPUTE_SUCCESS',
  CREATE_DISPUTE_ERROR: 'CREATE_DISPUTE_ERROR',

  GET_DISPUTE_FILTERS_DATA: 'GET_DISPUTE_FILTERS_DATA',
  GET_DISPUTE_FILTERS_DATA_SUCCESS: 'GET_DISPUTE_FILTERS_DATA_SUCCESS',
  GET_DISPUTE_FILTERS_DATA_ERROR: 'GET_DISPUTE_FILTERS_DATA_ERROR',

  MARK_DISPUTE_CLOSE: 'MARK_DISPUTE_CLOSE',
  MARK_DISPUTE_OPEN: 'MARK_DISPUTE_OPEN',
};

export default disputeActionConstants;
